import GameThumb from "@casino/legacy/client/shared/game/GameThumb";
import GameCardTemplate from "./template/GameCardTemplate";
import useGameCardSize from "./useGameCardSize";

type Props = {
  game: GameFragment;
  big?: boolean;
  wide?: boolean;
  medium?: boolean;
  light?: boolean;
  rtpField?: RtpField;
  href?: string;
  preloadImg?: boolean;
  showGrid?: boolean;
  isMinMaxBetVisible?: boolean;
  isCarousel?: boolean;
};

const GameCard: FC<Props> = ({
  game,
  big,
  wide,
  medium,
  light,
  href,
  preloadImg,
  showGrid,
  isMinMaxBetVisible,
  isCarousel,
}) => {
  const { width, height } = useGameCardSize();

  return (
    <GameCardTemplate>
      <GameThumb
        game={game}
        width={width}
        showGrid={showGrid}
        height={height}
        isHoverEnabled
        wide={wide}
        medium={medium}
        href={href}
        big={big}
        light={light}
        preloadImg={preloadImg}
        isMinMaxBetVisible={isMinMaxBetVisible}
        isCarousel={isCarousel}
      />
    </GameCardTemplate>
  );
};

export default GameCard;
